import { StyleSheet, Text, View } from '@react-pdf/renderer';
import React from 'react';

const styles = StyleSheet.create({
  container: {
    width: '100%',
    height: '100%',
    backgroundColor: '#f8f9fa',
    borderTop: '2px solid #548235',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    paddingVertical: '0.6cm',
    paddingHorizontal: '1.5cm',
  },
  content: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%',
    maxWidth: '16cm',
  },
  leftSection: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    flex: 1,
  },
  centerSection: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    flex: 1,
  },
  rightSection: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-end',
    flex: 1,
  },
  companyName: {
    fontSize: '12px',
    fontFamily: 'Helvetica-Bold',
    color: '#2c3e50',
    marginBottom: '0.1cm',
  },
  website: {
    fontSize: '10px',
    fontFamily: 'Helvetica',
    color: '#548235',
    textDecoration: 'none',
  },
  contactItem: {
    fontSize: '9px',
    fontFamily: 'Helvetica',
    color: '#34495e',
    marginBottom: '0.1cm',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
  },
  contactLabel: {
    fontFamily: 'Helvetica-Bold',
    color: '#548235',
    fontSize: '8px',
    marginBottom: '0.05cm',
    textTransform: 'uppercase',
    letterSpacing: '0.3px',
  },
  contactValue: {
    fontSize: '9px',
    fontFamily: 'Helvetica',
    color: '#34495e',
    lineHeight: 1.2,
  },
  separator: {
    width: '1px',
    height: '1.5cm',
    backgroundColor: '#e8e8e8',
    marginHorizontal: '0.5cm',
  },
  copyright: {
    fontSize: '8px',
    fontFamily: 'Helvetica',
    color: '#7f8c8d',
    textAlign: 'center',
    marginTop: '0.3cm',
    fontStyle: 'italic',
  },
});

function Footer({ config }) {
  return (
    <View style={styles.container}>
      <View style={styles.content}>
        {/* Sección Izquierda - Información de la Empresa */}
        <View style={styles.leftSection}>
          <Text style={styles.companyName}>
            {config?.company || 'Lift Logic'}
          </Text>
          <Text style={styles.website}>
            {config?.web || 'www.liftlogic.cl'}
          </Text>
        </View>

        {/* Separador Visual */}
        <View style={styles.separator} />

        {/* Sección Central - Contacto */}
        <View style={styles.centerSection}>
          {config?.telefonos?.map((telefono, index) => (
            <View key={index} style={styles.contactItem}>
              <Text style={styles.contactLabel}>Teléfono</Text>
              <Text style={styles.contactValue}>{telefono}</Text>
            </View>
          ))}
          {config?.correo && (
            <View style={styles.contactItem}>
              <Text style={styles.contactLabel}>Email</Text>
              <Text style={styles.contactValue}>{config.correo}</Text>
            </View>
          )}
        </View>

        {/* Separador Visual */}
        <View style={styles.separator} />

        {/* Sección Derecha - Dirección */}
        <View style={styles.rightSection}>
          {config?.direccion && (
            <View style={styles.contactItem}>
              <Text style={styles.contactLabel}>Dirección</Text>
              <Text style={styles.contactValue}>{config.direccion}</Text>
            </View>
          )}
          {config?.ciudad && (
            <View style={styles.contactItem}>
              <Text style={styles.contactLabel}>Ciudad</Text>
              <Text style={styles.contactValue}>{config.ciudad}</Text>
            </View>
          )}
        </View>
      </View>

      {/* Copyright */}
      <Text style={styles.copyright}>
        © {new Date().getFullYear()} {config?.company || 'Lift Logic'}. Todos
        los derechos reservados.
      </Text>
    </View>
  );
}

export default Footer;
